import Button from "components/atoms/Button";
import { GET_PARAMS, GET_POPUP_TYPES } from "constants/popupConfig";
import { createSearchParams, useNavigate, useLocation } from "react-router-dom";
import useTranslate from "../../../hooks/useTranslate";

import "./styles.sass";

const InviteFriendLinkMob = () => {
  const t = useTranslate();
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = async () => {
    navigate({
      search: `${location.search}&${createSearchParams({ [GET_PARAMS.POPUP]: GET_POPUP_TYPES.popup.share })}`,
    });
  };

  return (
    <div className="InviteFriendLinkMob">
      <div className="InviteFriendLinkMob__title">
        {t("referral.link.header")}
      </div>
      <div className="InviteFriendLinkMob__desc">
        {t("referral.link.description")}
      </div>
      <div className="InviteFriendLinkMob__btn">
        <Button
          htmlType="button"
          label={t("referral.start.button")}
          variation="primary"
          onClick={handleClick}
        />
      </div>
    </div>
  );
};

export default InviteFriendLinkMob;
